module.exports = __webpack_public_path__ + "static/4-the-encryption-at-rest-a8e92e0226cc64c4336c7aae4b60212b.jpg";